import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/InventoryMessages'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class InventoryMessagesStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "InventoryMessagesStore",
			variables: true,
		})
	}
}

export async function load_InventoryMessages(params) {
  await initClient()

	const store = new InventoryMessagesStore()

	await store.fetch(params)

	return {
		InventoryMessages: store,
	}
}
